<img
  ngSrc="assets/images/logo/gov_logo.svg"
  width="140"
  height="75"
  alt="Logo rządowe"
  class="footer-logo"
/>

<app-footer-popups />

<p class="footer-text">
  Strony dostępne w domenie www.gov.pl mogą zawierać adresy skrzynek mailowych.
  Użytkownik korzystający z odnośnika będącego adresem e-mail zgadza się na
  przetwarzanie jego danych (adres e-mail oraz dobrowolnie podanych danych w
  wiadomości) w celu przesłania odpowiedzi na przesłane pytania. Szczegóły
  przetwarzania danych przez każdą z jednostek znajdują się w ich politykach
  przetwarzania danych osobowych.
</p>

<div class="footer-cc">
  <img ngSrc="assets/images/logo/cc.svg" height="25" width="25" alt="" />
  <img ngSrc="assets/images/logo/by.svg" height="25" width="25" alt="" />
  <p class="footer-text">
    Treści tekstowe publikowane w serwisie (z wyłączeniem treści
    audiowizualnych), są udostępniane na licencji typu Creative Commons: uznanie
    autorstwa - na tych samych warunkach 4.0 (CC BY-SA 4.0). Materiały
    audiowizualne, w tym zdjęcia, materiały audio i wideo, są udostępniane na
    licencji typu Creative Commons: uznanie autorstwa użycie niekomercyjne - bez
    utworów zależnych 4.0 (CC BY-NC-ND 4.0), o ile nie jest to stwierdzone
    inaczej.
  </p>
</div>
